import React from 'react';
import FeedBack from './feedback';

import './index.scss';

export default function Index(props) {
  return <FeedBack {...props} />;
}
